import React from 'react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="w-full bg-black py-12 sm:py-24 px-4 overflow-hidden" data-id="element-131">
      <div className="max-w-2xl mx-auto text-center relative" data-id="element-132">
        {/* Ambient glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-[#C8962E]/5 rounded-full blur-[80px] pointer-events-none" data-id="element-133" />

        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} whileInView={{
        opacity: 1,
        scale: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} className="relative z-10" data-id="element-134">
          {/* Shield Icon */}
          <div className="w-14 h-14 sm:w-18 sm:h-18 mx-auto bg-[#C8962E]/10 rounded-full flex items-center justify-center mb-4 border border-[#C8962E]/20 shadow-[0_0_30px_rgba(200,150,46,0.15)]" data-id="element-135">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C8962E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-136">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-137" />
              <path d="m9 12 2 2 4-4" data-id="element-138" />
            </svg>
          </div>

          <h2 className="text-xl sm:text-3xl md:text-4xl font-black text-white mb-4 leading-tight" data-id="element-139">
            GARANTÍA PROFEPACK™ <br data-id="element-140" />
            <span className="text-[#C8962E]" data-id="element-141">100% DEVOLUCIÓN EN 7 DÍAS</span>
          </h2>

          <div className="bg-white/[0.02] border border-[#C8962E]/30 rounded-2xl p-5 sm:p-7 mb-5 relative overflow-hidden" data-id="element-142">
            <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#C8962E]/50 to-transparent" data-id="element-143" />

            <p className="text-gray-300 text-xs sm:text-base mb-4 leading-relaxed" data-id="element-144">
              Abrís los 6 tomos. Revisás los 6 bonos. Los usás en la clase si
              querés. Si en 7 días no es lo que esperabas:
            </p>
            <p className="text-[#C8962E] text-xl sm:text-3xl font-black mb-2" data-id="element-145">
              Te devolvemos el 100%.
            </p>
            <p className="text-white text-xs sm:text-sm font-bold bg-white/5 inline-block px-3 sm:px-4 py-1 sm:py-1.5 rounded-lg" data-id="element-146">
              Sin preguntas. Sin formularios. Sin drama.
            </p>
          </div>

          <p className="text-gray-500 text-[11px] sm:text-sm leading-relaxed max-w-md mx-auto" data-id="element-147">
            +500 profes ya lo saben. Tasa de devoluciones menor al 1%.
          </p>
        </motion.div>
      </div>
    </section>;
}